<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="!$route.meta || $route.meta.keepAlive !== false" />
    </keep-alive>
    <router-view v-if="$route.meta && $route.meta.keepAlive === false" />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
</style>
